import api from '../utils/api'

const config = {
  headers: {
    'Content-Type': undefined
  }
}

export const uploadInvoice = (formData) => {
  const conta = api.post(process.env.VUE_APP_UPLOADINVOICE_URL, formData, config)
  return conta
}